module.exports = __webpack_public_path__ + "img/graph-inwoners.b315890f.svg";